//
import { LOCALES } from '@/shared/models/constants.models';

export interface ICurrencyMixin {
  methods: {
    $n?: (value: number, style: string, locale: string) => string;
    currency(value: number | string, locale?: LOCALES): string;
  };
}
export const currency: ICurrencyMixin = {
  methods: {
    currency(value: number, locale: LOCALES = LOCALES.en_US): string {
      if (value || value === 0) {
        return this.$n ? this.$n(value >= 0 ? value : -value, 'currency', locale) : '';
      }
      return '';
    },
  },
};

export const percentage = {
  methods: {
    percentage(value: number) {
      return `${Math.round(value * 100 + Number.EPSILON) / 100}%`;
    },
  },
};
